import axios from "../axios";

const getBankAccountTransaction = async function (accessToken, id) {
    try {
        const response = await axios.get('bank-account/getBankAccountTransaction', {
            headers: {
                'Authorization': accessToken
            },
            params: {
                id
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getBankAccountTransaction;
